import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  orderBy,
  limit,
  startAfter,
  updateDoc,
  doc,
  getDoc,
  increment,
} from "firebase/firestore"; // Make sure 'increment' is imported
import { db } from "../config"; // Adjust this path
import NavBar from "./NavBar"; // Ensure this path is correct

function Withdrawal() {
  const [withdrawals, setWithdrawals] = useState([]);
  const [lastVisible, setLastVisible] = useState(null);
  const [loading, setLoading] = useState(false);
  const [statusUpdating, setStatusUpdating] = useState(null);

  const fetchWithdrawals = async (next = false) => {
    setLoading(true);
    try {
      const withdrawRef = collection(db, "withdrawals");
      let q = query(withdrawRef, orderBy("createdAt", "desc"), limit(10));

      if (next && lastVisible) {
        q = query(
          withdrawRef,
          orderBy("createdAt", "desc"),
          startAfter(lastVisible),
          limit(10)
        );
      }

      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setWithdrawals((prev) => (next ? [...prev, ...data] : data));
      setLastVisible(snapshot.docs[snapshot.docs.length - 1]);
    } catch (err) {
      console.error("Error fetching withdrawals:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchWithdrawals();
  }, []);

const handleStatusChange = async (id, newStatus) => {
  setStatusUpdating(id);
  try {
    const withdrawRef = doc(db, "withdrawals", id);
    const withdrawalSnap = await getDoc(withdrawRef);
    const withdrawalData = withdrawalSnap.data();

    if (!withdrawalData) {
      console.error("Withdrawal not found.");
      return;
    }

    const { userId, amount, status: oldStatus } = withdrawalData;

    // Update the withdrawal status
    await updateDoc(withdrawRef, { status: newStatus });

    // Only increment if status changed from pending to approved
    if (oldStatus !== "approved" && newStatus === "approved") {
      const userRef = doc(db, "users", userId);
      await updateDoc(userRef, {
        Totalwithdrawals: increment(parseFloat(amount)),
      });
      console.log(`✅ Incremented Totalwithdrawals for user: ${userId}`);
    }

    // Update UI
    setWithdrawals((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, status: newStatus } : item
      )
    );
  } catch (err) {
    console.error("Failed to update withdrawal status:", err);
  }
  setStatusUpdating(null);
};

  return (
    <div className="container-fluid">
      {/* Top Navbar */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light mb-3">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link"
              data-widget="pushmenu"
              href="#"
              role="button"
            >
              <i className="fas fa-bars" />
            </a>
          </li>
        </ul>
      </nav>

      {/* Custom Navigation Bar */}
      <NavBar />

      {/* Withdrawals Table */}
      <div className="container mt-4">
        <h3 className="text-center mb-4">Withdrawals</h3>

        {loading && <div className="text-center">Loading...</div>}

        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                <th>Email</th>
                <th>Amount</th>
                <th>Crypto Type</th>
                <th>Wallet Address</th>
                <th>Status</th>
                <th>Change Status</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {withdrawals.map((w) => (
                <tr key={w.id}>
                  <td>{w.email}</td>
                  <td>${parseFloat(w.amount).toFixed(2)}</td>
                  <td>{w.cryptoType}</td>
                  <td>{w.walletAddress}</td>
                  <td>
                    <span
                      className={`badge bg-${
                        w.status === "pending"
                          ? "warning"
                          : w.status === "approved"
                          ? "success"
                          : "danger"
                      }`}
                    >
                      {w.status}
                    </span>
                  </td>
                  <td>
                    <select
                      className="form-select"
                      disabled={statusUpdating === w.id}
                      value={w.status}
                      onChange={(e) =>
                        handleStatusChange(w.id, e.target.value)
                      }
                    >
                      <option value="pending">Pending</option>
                      <option value="approved">Approved</option>
                      <option value="rejected">Rejected</option>
                    </select>
                  </td>
                  <td>
                    {w.createdAt?.toDate
                      ? w.createdAt.toDate().toLocaleString()
                      : new Date(w.createdAt).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {lastVisible && (
          <div className="text-center mt-3">
            <button
              className="btn btn-secondary"
              onClick={() => fetchWithdrawals(true)}
              disabled={loading}
            >
              Load More
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Withdrawal;
